import React, { useState } from "react";
import MainCalculatorsList from "./MainCalculators";
import RelatedLinks from "../RelatedLinks";
import { SecondAds,    FirstAds , MobileUnderCalAds } from "../../Ads";
import SharedHelmet from "../Helmet";
const TITLE = "حاسبة معدل الترشيح الكبيبي (GFR)";
const DESCRIPTION =
  "احسب معدل الترشيح الكبيبي (GFR) باستخدام معادلة CKD-EPI لتحليل وظائف الكلى بدقة بناءً على مستوى الكرياتينين في الدم، العمر، والجنس.";
const KEYWORDS = "GFR, الكرياتينين, CKD-EPI, وظائف الكلى, حاسبة GFR";
const OG_URL = "https://do-calculate.com/calculator/ar/gfr-calculator/";
function GFRCalculator() {
  const [creatinine, setCreatinine] = useState(0.2);
  const [age, setAge] = useState(12);
  const [gender, setGender] = useState("male");
  const [result, setResult] = useState();
  const [error, setError] = useState("");
  const handleCalculate = () => {
    try {
      const k = gender === "female" ? 0.7 : 0.9;
      const alpha = gender === "female" ? -0.241 : -0.302;
      const minScr = Math.min(creatinine / k, 1);
      const maxScr = Math.max(creatinine / k, 1);
      const gfr =
        142 *
        Math.pow(minScr, alpha) *
        Math.pow(maxScr, -1.2) *
        Math.pow(0.9938, age) *
        (gender === "female" ? 1.012 : 1);
      setResult(gfr.toFixed(2));
    } catch (error) {
      setError(error.message);
    }
  };
  return (
    <div className="rtl">
      <SharedHelmet
        TITLE={TITLE}
        DESCRIPTION={DESCRIPTION}
        KEYWORDS={KEYWORDS}
        OG_URL={OG_URL}
      />
      <div className="row">
        <div className="col-12 col-md-8">
          <FirstAds />
        </div>
      </div>
      <div className="row">
        <div className="col-12 col-md-8">
          <br />
          <div
            className="bg-success text-white text-center"
            style={{ height: "50px" }}
          >
            <h1 style={{ fontSize: "17px" }}>{TITLE}</h1>
          </div>
          <div className="border border-light">
            <div className="row">
              <div>
                <p>
                  احسب معدل الترشيح الكبيبي (GFR) الآن واتخذ خطوات استباقية
                  لحماية صحتك! حاسبتنا المبتكرة تستخدم أحدث المعادلات الطبية
                  (CKD-EPI) لتقييم وظائف كليتيك بدقة. بمعرفة قيمة GFR، يمكنك:
                </p>{" "}
                <ul>
                  <li>
                    كشف الأمراض الكلوية مبكرًا: اكتشف أي مشاكل في الكلى في
                    مراحلها الأولى وتلقى العلاج المناسب.
                  </li>
                  <li>
                    مراقبة فعالية العلاج: تابع تأثير الأدوية والعلاجات على صحة
                    كليتيك.
                  </li>
                  <li>
                    اتخاذ قرارات مستنيرة: استشر طبيبك بناءً على نتائج الحساب
                    لتحديد أفضل خطة علاجية.
                  </li>
                </ul>
                <p>
                  ببساطة، أدخل قيم الكرياتينين، العمر، والجنس، وانقر على "احسب".
                </p>
                <p>
                  تم بناء الحاسبة بناءاً على {" "}
                  <a href="https://www.kidney.org/ckd-epi-creatinine-equation-2021" rel="nofollow">مؤسسة الكلى الدولية</a>
                </p>
                <hr />
              </div>
              <br />
            </div>
            <MobileUnderCalAds/>
            <div className="row">
              <div className="col-sm-12 col-md-7 calculatorStyle">
                <div className="p-3 mb-2 bg-success text-white">
                  <h2 style={{ fontSize: "16px" }}>{TITLE}</h2>
                </div>
                <div dir="rtl">
                  <div>
                    <hr />
                    <div className="form-group" htmlFor="creatinine">
                      <label className="form-label ms-2">
                        ادخل مستوى الكرياتينين
                      </label>
                      <input
                        id="creatinine"
                        type="number"
                        value={creatinine}
                        onChange={(e) => setCreatinine(e.target.value)}
                        placeholder="أدخل مستوى الكرياتينين"
                        className="form-control"
                        style={{ width: "75%" }}
                      />
                    </div>
                    <div className="form-group">
                      <label className="form-label ms-2" htmlFor="age">
                        اختر العمر
                      </label>
                      <select
                        id="age"
                        value={age}
                        onChange={(e) => setAge(e.target.value)}
                        className="form-control"
                        style={{ width: "75%" }}
                      >
                        {[...Array(88)].map((_, i) => (
                          <option key={i + 12} value={i + 12}>
                            {i + 12}
                          </option>
                        ))}
                      </select>
                    </div>
                    <div className="form-group">
                      <label className="form-label ms-2" htmlFor="gender">
                        اختر الجنس
                      </label>
                      <select
                        id="gender"
                        value={gender}
                        onChange={(e) => setGender(e.target.value)}
                        className="form-control"
                        style={{ width: "75%" }}
                      >
                        <option value="male">ذكر</option>
                        <option value="female">أنثى</option>
                      </select>
                    </div>
                    <br />
                    <button
                      className="btn btn-success"
                      style={{ fontSize: "20px", marginLeft: "10px" }}
                      onClick={handleCalculate}
                    >
                      احسب                    </button>
                  </div>
                  <br />
                  { error !== "" && (
                    <p className="p-3 mb-2 bg-warning text-black">
                      خطأ: {error}
                    </p>
                  )}
                  {result &&  (
                    <div className="p-3 mb-2 bg-success text-white">
                      <h4>النتيجة:</h4>
                      <p className="text-white">{`معدل الترشيح الكبيبي (GFR): ${result} مل/دقيقة/1.73م²`}</p>
                    </div>
                  )}
                  <hr />
                </div>
              </div>
            </div>
            <hr />            <div className="row">
              <RelatedLinks />
              <hr />
            </div>
          </div>
        </div>
        <div className="col">
          <SecondAds />
          <br />
          <MainCalculatorsList></MainCalculatorsList>
          <br />
        </div>
      </div>
      <div className="row" style={{ height: "auto" }}>
        <div className="col-12 col-md-8">
          <div className="info-sections-container">
            <div className="info-section">
              <div className="info-section-header">معلومات إضافية عن GFR</div>
              <div className="info-section-body">
                <div>
                  <u>
                    <h2 style={{ fontSize: "16px" }}>
                      ما هو معدل الترشيح الكبيبي (GFR)؟{" "}
                    </h2>{" "}
                  </u>
                  <p>
                    معدل الترشيح الكبيبي (GFR) هو مقياس لمدى كفاءة الكلى في
                    تصفية النفايات من الدم. يعتبر GFR أداة مهمة لتقييم صحة
                    الكلى.
                  </p>
                  <p>
                    يستخدم GFR لتحديد مرحلة مرض الكلى المزمن (CKD) والمساعدة في
                    تخطيط العلاج.
                  </p>
                  <p>
                    تستخدم المعادلة عوامل مثل مستوى الكرياتينين في الدم، العمر،
                    والجنس لحساب GFR.
                  </p>
                  <div className="p-3 mb-2 bg-info">
                    مثال: شخص بعمر 50 سنة، ذكر، لديه مستوى كرياتينين 1.2، GFR
                    الخاص به قد يكون 75 مل/دقيقة/1.73م².
                  </div>
                  <br />
                </div>
                <hr />
                <div>
                  <u>
                    <h2 style={{ fontSize: "16px" }}>كيفية تحسين معدل GFR؟</h2>{" "}
                  </u>
                  <p>للحفاظ على أو تحسين GFR، يمكن اتباع النصائح التالية:</p>
                  <ul>
                    <li>اتباع نظام غذائي صحي.</li>
                    <li>التحكم في ضغط الدم.</li>
                    <li>الامتناع عن التدخين.</li>
                    <li>
                      الحفاظ على مستويات السكر في الدم ضمن الحدود الطبيعية.
                    </li>
                  </ul>
                  <p>استشر طبيبك لمزيد من النصائح والتوجيهات.</p>
                  <div className="p-3 mb-2 bg-info text-black">
                    مثال: الحفاظ على نظام غذائي منخفض البروتين قد يساعد في تقليل
                    العبء على الكلى.
                  </div>
                  <hr />
                </div>
                <div>
                  <u>
                    <h2 style={{ fontSize: "16px" }}>ماذا يعني GFR المنخفض؟</h2>{" "}
                  </u>
                  <p>
                    GFR المنخفض يشير إلى أن الكلى لا تعمل بكفاءة كافية. قد يعني
                    ذلك وجود تلف في الكلى أو تقدم في مرض الكلى المزمن.
                  </p>
                  <ul>
                    <li>
                      قد يتطلب GFR المنخفض اتخاذ خطوات علاجية مثل تغيير النظام
                      الغذائي أو تناول الأدوية.
                    </li>
                    <li>
                      في الحالات الشديدة، قد يتطلب الأمر إجراءات طبية أكثر
                      تعقيدًا.
                    </li>
                  </ul>
                  <p>
                    GFR تحت 60 مل/دقيقة/1.73م² قد يكون مؤشرًا على مرض الكلى
                    المزمن.
                  </p>
                  <b>مثال</b>
                  <div className="p-3 mb-2 bg-info text-black">
                    شخص لديه GFR أقل من 30 مل/دقيقة/1.73م² قد يحتاج إلى استشارة
                    أخصائي الكلى.
                  </div>
                </div>
                <div>
                  <u>
                    <h2 style={{ fontSize: "16px" }}>الأسئلة الشائعة</h2>{" "}
                  </u>
                  <p>إليك بعض الأسئلة الشائعة حول GFR:</p>
                  <b>مثال</b>
                  <div className="p-3 mb-2 bg-info text-black ">
                    <p>س: هل يمكن تحسين GFR المنخفض؟</p>
                    <p>
                      ج: في بعض الحالات، يمكن تحسين GFR من خلال إدارة عوامل
                      الخطر مثل ضغط الدم والسكر.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
         </div>
</div>
  );
}
export default GFRCalculator;
